import { PRODUCT_VIEW_LAYER } from '../../../components/AssetTargetsDialog/helpers/assetProductLinks';

/**
 * Resolves API target ids for setUsageAltText.
 */
export default function resolveUsageAltTextTarget({
  viewContext,
  productId,
  linkVariantId,
  isVariant,
}) {
  if (viewContext?.layer === PRODUCT_VIEW_LAYER.MASTER) {
    return isVariant
      ? { variantId: linkVariantId || productId }
      : { productId };
  }

  if (isVariant) {
    return { variantId: linkVariantId };
  }

  return { productId: viewContext?.listingProductId || productId };
}
